{
  "addAdvisor": "Add advisor",
  "addBoardMember": "Add board memeber",
  "addClusterManagement": "Add to clustermanagement",
  "addContact": "Add contact",
  "addContacts": "Add contacts",
  "addContingent": "Add contingent",
  "addFocusArea": "Add focus area",
  "addHourRate": "Add hour rate",
  "addInterestArea": "Add interest area",
  "addLead": "Add lead",
  "addLeaders": "Add leaders",
  "addMainGoal": "Add main goal",
  "addCustomer": "Add customer",
  "addPartner": "Add partner",
  "addProjectCategory": "Add project category",
  "addSelfEffort": "Add self-effort",
  "approveSelfEffort": "Approve self-effort",
  "brregFetch": "Fetch from BrReg",
  "cancel": "Cancel",
  "createNewApplication": "Create new appplication",
  "createProject": "Create project",
  "deleteInterestArea": "Delete interest area",
  "deleteSelfEffort": "Delete self-effort",
  "edit": "Edit",
  "editFocusArea": "Edit focus area",
  "errorBoundaryResetButton": "Remove error message",
  "goToProjects": "Go to projects",
  "gotoResourceBase": "Go to resource base",
  "import": "Import",
  "inviteToClusterPortal": "Invite to cluster portal",
  "newEvent": "New event",
  "newInterestArea": "New interest area",
  "registerSelfEffort": "Register self-effort",
  "removeAdvisor": "Remove advisor",
  "removeBoardMember": "Remove from board",
  "removeContact": "Remove contact",
  "removeManagement": "Remove from management",
  "removeMarkings": "Remove markings",
  "removeParticipant": "Remove participant",
  "save": "Save",
  "seeAllContacts": "See all contacts",
  "seeAllMembers": "See all members",
  "sendReports": "Send reports",
  "unretire": "Unretire",
  "clearFilter": "Clear filter",
  "addOpportunity": "Add inquiry",
  "importInvoice": "Import invoice"
}
